'use client'

/*
 * Renders every richtext column from the CMS. Styles live in src/styles/rich-text.css.
 * Embed blocks (<div data-embed="...">) run through mountEmbed after the page loads.
 */

import { useEffect, useRef } from 'react'
import { mountEmbed } from '@/components/cms/code-embed'

interface RichTextProps {
    html?: string | null
    className?: string
}

const MOUNTED = new WeakSet<Element>()

export default function RichText({ html, className }: RichTextProps) {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        for (const host of Array.from(ref.current?.querySelectorAll<HTMLElement>(':scope > div[data-embed]') ?? [])) {
            if (MOUNTED.has(host) || host.childElementCount > 0) continue
            MOUNTED.add(host)
            mountEmbed(host, host.getAttribute('data-embed') ?? '')
        }
    }, [html])

    return <div ref={ref} className={className ? 'rich-text ' + className : 'rich-text'} dangerouslySetInnerHTML={{ __html: html ?? '' }} />
}
